import React, {useEffect,useState} from 'react'
import RedlockMappingForm from './RedlockMappingForm';
import RedlockCredentialsForm from './RedlockCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { columnRenderArrayData } from 'utils/tableUtils';

export default function RedlockConfigListing(props) {

    const [loginConfig,setLoginConfig] = useState([]);

    useEffect(()=>{
        if(props.loginConfigList && props.loginConfigList.length){
            let value = props.loginConfigList.map((login)=> {
                const {username, ...restConfig} = login;
                return { 
                   ...restConfig,
                   accessKey: username
                }
            })
        setLoginConfig(value);
        } else {
            setLoginConfig([])
        }
    },[props.loginConfigList])

    const columns = [
    {
      dataIndex: "accountGroupName",
      title: "Account Group",
      width: 200,
    },
    {
      dataIndex: "cloudName",
      title: "Cloud Account",
      width: 200,
      render: (cloudName) => cloudName ? columnRenderArrayData(cloudName) : "All" 
    },
    ];

    return (
        <GenericPullConfigListing
            {...props}
            loginConfigList={loginConfig}
            toolName={props.name}
            extraColumns={columns}
            MappingForm={RedlockMappingForm}
            CredentialsForm={RedlockCredentialsForm}
        />
    )
}